import { Suspense, useEffect, useState } from "react"
import { BrowserRouter, Switch } from "react-router-dom"
import { ToastContainer } from "react-toastify"

import { AuthProvider } from "../context/Auth/AuthContext"
import { TicketsContextProvider } from "../context/Tickets/TicketsContext"
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext"

import Route from "./Route"
import LoggedInLayout from "../layout"
import { Typography } from "@mui/material"
import Terms from "../pages/Terms"
import Privacy from "../pages/Privacy"

import Dashboard from "../pages/Dashboard/"
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer"
import Signup from "../pages/Signup/"
import Login from "../pages/Login/"
import Connections from "../pages/Connections/"
import SettingsCustom from "../pages/SettingsCustom/"
import Financeiro from "../pages/Financeiro/"
import Users from "../pages/Users"
import Contacts from "../pages/Contacts/"
import Queues from "../pages/Queues/"
import Tags from "../pages/Tags/"
import MessagesAPI from "../pages/MessagesAPI/"
import Helps from "../pages/Helps/"
import ContactLists from "../pages/ContactLists/"
import ContactListItems from "../pages/ContactListItems/"
import QuickMessages from "../pages/QuickMessages/"
import Kanban from "../pages/Kanban"
import Schedules from "../pages/Schedules"
import Audios from "../pages/Audios"
import Campaigns from "../pages/Campaigns"
import CampaignsConfig from "../pages/CampaignsConfig"
import CampaignReport from "../pages/CampaignReport"
import Annoucements from "../pages/Annoucements"
import Chat from "../pages/Chat"
import ToDoList from "../pages/ToDoList/"
import Subscription from "../pages/Subscription/"
import Prompts from "../pages/Prompts"
import Suggestions from "../pages/Suggestions"
import Email from "../pages/Email"
import Subsidiaries from "../pages/Subsidiaries"
import QueueIntegration from "../pages/QueueIntegration"
import Products from "../pages/Products"
import Forms from "../pages/Forms"
import NewForm from "../pages/Forms/NewForm"
import FormView from "../pages/FormView"
import AutoDM from "../pages/AutoDM"

const Routes = () => {
    const [showCampaigns, setShowCampaigns] = useState(false)

    useEffect(() => {
        const cshow = localStorage.getItem("cshow")
        if (cshow !== undefined) {
            setShowCampaigns(true)
        }
    }, [])

    const LoadingComponent = () => (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <Typography variant="h5">Carregando...</Typography>
        </div>
    )

    return (
        <BrowserRouter>
            <AuthProvider>
                <TicketsContextProvider>
                    <Switch>
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/signup" component={Signup} />
                        <Route exact path="/terms_use" component={Terms} />
                        <Route
                            exact
                            path="/privacy_policy"
                            component={Privacy}
                        />
                        {/* <Route exact path="/create-company" component={Companies} /> */}

                        <Route
                            exact
                            path="/form-preview/:uuid"
                            component={FormView}
                            isPrivate
                            demoPage
                        />
                        <Route
                            exact
                            path="/f/:uuid"
                            component={FormView}
                            demoPage
                        />
                        <WhatsAppsProvider>
                            <LoggedInLayout>
                                <Suspense fallback={<LoadingComponent />}>
                                    <Route
                                        exact
                                        path="/"
                                        component={Dashboard}
                                        isPrivate
                                    />

                                    <Route
                                        exact
                                        path="/tickets/:ticketId?"
                                        component={TicketResponsiveContainer}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/connections"
                                        component={Connections}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/quick-messages"
                                        component={QuickMessages}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/todolist"
                                        component={ToDoList}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/schedules"
                                        component={Schedules}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/audios"
                                        component={Audios}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/tags"
                                        component={Tags}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/contacts"
                                        component={Contacts}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/helps"
                                        component={Helps}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/users"
                                        component={Users}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/subsidiaries"
                                        component={Subsidiaries}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/prompts"
                                        component={Prompts}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/suggestions"
                                        component={Suggestions}
                                        isPrivate
                                    />

                                    <Route
                                        exact
                                        path="/queue-integration"
                                        component={QueueIntegration}
                                        isPrivate
                                    />

                                    <Route
                                        exact
                                        path="/messages-api"
                                        component={MessagesAPI}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/settings"
                                        component={SettingsCustom}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/dm-automations"
                                        component={AutoDM}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/kanban"
                                        component={Kanban}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/financeiro"
                                        component={Financeiro}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/queues"
                                        component={Queues}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/leads"
                                        component={Email}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/announcements"
                                        component={Annoucements}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/subscription"
                                        component={Subscription}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/products"
                                        component={Products}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/forms"
                                        component={Forms}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/form/:id"
                                        component={NewForm}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/form"
                                        component={NewForm}
                                        isPrivate
                                    />
                                    <Route
                                        exact
                                        path="/chats/:id?"
                                        component={Chat}
                                        isPrivate
                                    />
                                    {showCampaigns && (
                                        <>
                                            <Route
                                                exact
                                                path="/contact-lists"
                                                component={ContactLists}
                                                isPrivate
                                            />
                                            <Route
                                                exact
                                                path="/contact-lists/:contactListId/contacts"
                                                component={ContactListItems}
                                                isPrivate
                                            />
                                            <Route
                                                exact
                                                path="/campaigns"
                                                component={Campaigns}
                                                isPrivate
                                            />
                                            <Route
                                                exact
                                                path="/campaign/:campaignId/report"
                                                component={CampaignReport}
                                                isPrivate
                                            />
                                            <Route
                                                exact
                                                path="/campaigns-config"
                                                component={CampaignsConfig}
                                                isPrivate
                                            />
                                        </>
                                    )}
                                </Suspense>
                            </LoggedInLayout>
                        </WhatsAppsProvider>
                    </Switch>

                    <ToastContainer autoClose={3000} position="top-center" />
                </TicketsContextProvider>
            </AuthProvider>
        </BrowserRouter>
    )
}

export default Routes
